/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Header from "./Header/Header"
import Footer from "./Footer/Footer"
import "bootstrap/dist/css/bootstrap.css"
import { GlobalStyles } from "./Layout.styles"
import scrollTo from "gatsby-plugin-smoothscroll"
import loadable from "@loadable/component"
import CookieLogo from "./Logo/cookieLogo"
import FooterCallToAction from "../FooterCallToAction/FooterCallToAction"

const Layout = ({
  children,
  headerTransparent,
  logoDark,
  whiteToggler,
  showHelpSection = true
}) => {
  const hashLink = typeof window !== `undefined` ? window.location.hash : null
  const [toggleVisibility, setToggleVisibility] = useState(false);
  useEffect(() => {
    hashLink && scrollTo(hashLink)
  }, [hashLink]);

  const displayFooterCta = showHelpSection ? <FooterCallToAction/> : '';

  return (
    <>
      <GlobalStyles
        headerTransparent={headerTransparent}
      />
      <Header
        headerTransparent={headerTransparent}
        logoDark={logoDark}
        whiteToggler = {whiteToggler}
      />
      <main>{children}</main>
      {displayFooterCta}
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  logoDark: PropTypes.bool,
}
Layout.defaultProps = {
  logoDark: true,
}
export default Layout
